import { render, staticRenderFns } from "./modalEditarDriver.vue?vue&type=template&id=33722099"
import script from "./modalEditarDriver.vue?vue&type=script&lang=js"
export * from "./modalEditarDriver.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports